import { Injectable } from "@angular/core";
import { TabelaHorario } from "@tivic-team/manager-ts/dist/mob/entities/horario/tabela-horario.entity";
import { TabelaHorarioController } from "app/controllers/mob/tabela-horario.controller";
import { PagedResponse } from "app/interfaces/paged-response.inteface";
import { TabelaHorarioTableDTOList } from "app/model/dtos/mob/tabela-horario-table.dto";
import { TabelaHorarioDTO } from "app/model/dtos/mob/tabela-horario.dto";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { TabelaHorarioSearch } from "./tabela-horario.search";
import { LinhaRotaTrechoHorarioDTO } from "app/model/dtos/mob/linha-rota-trecho-horario.dto";

@Injectable({
  providedIn: "root",
})
export class TabelaHorarioService implements ApiService<TabelaHorarioDTO> {
  constructor(
    private _tabelaHorarioController: TabelaHorarioController,
    private _loaderService: LoaderService
  ) {}

  find(search?: any): Promise<TabelaHorarioDTO[]> {
    throw new Error("Method not implemented.");
  }

  create(entity: TabelaHorarioDTO): Promise<TabelaHorarioDTO> {
    this._loaderService.show();
    return this._tabelaHorarioController
      .create(entity)
      .finally(() => this._loaderService.hide());
  }

  update(entity: TabelaHorarioDTO): Promise<TabelaHorarioDTO> {
    this._loaderService.show();
    return this._tabelaHorarioController
      .update(entity)
      .finally(() => this._loaderService.hide());
  }

  save(entity: TabelaHorarioDTO): Promise<TabelaHorarioDTO> {
    if (!entity.cdTabelaHorario) return this.create(entity);
    return this.update(entity);
  }

  findTabelas(
    tabelaHorarioSearch?: TabelaHorarioSearch
  ): Promise<PagedResponse<TabelaHorario>> {
    this._loaderService.show();
    return this._tabelaHorarioController
      .findTabelas(
        (tabelaHorarioSearch && tabelaHorarioSearch.getFilters()) || null
      )
      .finally(() => this._loaderService.hide());
  }

  async pagedFindLinhaColetivoUrbano(
    tabelaHorarioSearch?: TabelaHorarioSearch
  ): Promise<TabelaHorarioTableDTOList> {
    this._loaderService.show();
    return await this._tabelaHorarioController
      .pagedFindLinhaColetivoUrbano(
        (tabelaHorarioSearch && tabelaHorarioSearch.getFilters()) || null
      )
      .finally(() => this._loaderService.hide());
  }

  async pagedFindLinhaColetivoRural(
    tabelaHorarioSearch?: TabelaHorarioSearch
  ): Promise<TabelaHorarioTableDTOList> {
    this._loaderService.show();
    return await this._tabelaHorarioController
      .pagedFindLinhaColetivoRural(
        (tabelaHorarioSearch && tabelaHorarioSearch.getFilters()) || null
      )
      .finally(() => this._loaderService.hide());
  }

  get(cdTabelaHorario: number, cdLinha: number): Promise<TabelaHorarioDTO> {
    this._loaderService.show();
    return this._tabelaHorarioController
      .get(cdTabelaHorario, cdLinha)
      .finally(() => this._loaderService.hide());
  }

  findTabelaHorario(id: number): Promise<TabelaHorario[]> {
    this._loaderService.show();
    return this._tabelaHorarioController
      .findTabelaHorario(id)
      .finally(() => this._loaderService.hide());
  }

  remove(cdTabelaHorario: number, cdLinha: number): Promise<TabelaHorario> {
    this._loaderService.show();
    return this._tabelaHorarioController
      .remove(cdTabelaHorario, cdLinha)
      .finally(() => this._loaderService.hide());
  }

  getHorariosTabela(
    cdTabelaHorario: number,
    cdLinha: number
  ): Promise<LinhaRotaTrechoHorarioDTO> {
    this._loaderService.show();
    return this._tabelaHorarioController
      .getHorariosTabela(cdTabelaHorario, cdLinha)
      .finally(() => this._loaderService.hide());
  }
}
